import React from "react"
import { Link } from "gatsby"

export const DownloadUpdateInfoModal = ({
  download_update_info_modal_open,
  set_download_update_info_modal_open,
  application_required,
}) => {
  const close_cta_modal = () => {
    set_download_update_info_modal_open(false)
  }
  return (
    <div
      className={`modal${download_update_info_modal_open ? " is-active" : ""}`}
    >
      <div
        className="modal-background"
        onClick={close_cta_modal}
        role="button"
        tabIndex="0"
        onKeyDown={() => {}}
        aria-label="Close CTA Modal"
      ></div>
      <div className="modal-content">
        <div
          className="box mx-auto is-flex is-flex-direction-column"
          style={{ maxWidth: 530, minHeight: 350 }}
        >
          <p className="title is-5 mb-2 has-text-mitternachtsblau">
            Updates zu Unterlagen erhalten
          </p>
          <hr className="is-mitternachtsblau-30 my-3" />
          {application_required ? (
            <div
              className="has-text-mitternachtsblau mb-5 content"
              style={{ minHeight: 200 }}
            >
              Die{" "}
              <Link
                className="link"
                to="/vergabe-wissen/lexikon/holschuld-im-vergabeverfahren"
              >
                Holschuld
              </Link>{" "}
              verpflichtet die Bieter bei Abruf der Vergabeunterlagen, selbst
              die Veränderungen der Informationen zum Vergabeverfahren
              einzuholen.{" "}
              <Link
                className="link"
                to="/vergabe-wissen/lexikon/angebot-im-vergabeverfahren"
              >
                Angeboten
              </Link>{" "}
              und{" "}
              <Link
                className="link"
                to="/vergabe-wissen/lexikon/teilnahmeantrag"
              >
                Teilnahmeanträgen
              </Link>{" "}
              auf Basis veralteter Vergabeunterlagen droht der{" "}
              <Link
                className="link"
                to="/vergabe-wissen/lexikon/ausschlussgruende"
              >
                Ausschluss vom Verfahren
              </Link>
              .
            </div>
          ) : (
            <div
              className="has-text-mitternachtsblau mb-5 content"
              style={{ minHeight: 200 }}
            >
              Bei Vergabeunterlagen besteht für Bieter die{" "}
              <Link
                className="link"
                to="/vergabe-wissen/lexikon/holschuld-im-vergabeverfahren"
              >
                Holschuld
              </Link>
              . Die Holschuld verpflichtet die Bieter bei unregistriertem Abruf
              der Vergabeunterlagen, selbst die Veränderungen der Informationen
              zum Vergabeverfahren einzuholen. Angeboten auf Basis veralteter
              Vergabeunterlagen droht der{" "}
              <Link
                className="link"
                to="/vergabe-wissen/lexikon/ausschlussgruende"
              >
                Ausschluss vom Verfahren
              </Link>
              . Deshalb empfehlen wir Ihnen, sich einzuloggen oder zu
              registrieren, sodass wir Sie bei Updates von Unterlagen direkt per
              E-Mail informieren können.
            </div>
          )}

          <button
            className="ml-auto is-tertiary button has-text-weight-bold"
            onClick={close_cta_modal}
          >
            Schließen
          </button>
        </div>
      </div>
    </div>
  )
}
